import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';

import Certificates from '../../../../components/certificates/certificates';
import UrlHelper from '../../../../helpers/url-helper';
import { END_DATE, START_DATE } from '../../../../helpers/constants';
import { useCertificatesConfig } from '../../config/certificates-config';
import { useTranslations } from '../../hooks/use-translations';
import css from '../student.scss';
import {
    ALL_TEACHERS,
    ALL_YEARS
} from '../../../../components/report-filters/filter-constants';
import { ALL_TEACHERS_ID } from '../../participation-constants';
import { getCertificateFilename } from '../../helpers/utils';

const StudentCertificates = ({
    participationData,
    selectedClassroomId,
    selectedGroupId,
    selectedStudentId,
    newCertificatesDownloadStudentByType,
    pastCertificatesDownloadByType,
    selectedYearGroupId,
    selectedTeacherId
}) => {
    const {
        newCertificatesConfig,
        pastCertificatesConfig
    } = useCertificatesConfig();
    const { certificates, oldCertificates } = useTranslations();
    const certificateProps = {
        classroomId: selectedClassroomId,
        startDate: UrlHelper.getQueryParamValue(START_DATE) || null,
        endDate: UrlHelper.getQueryParamValue(END_DATE) || null,
        groupId: selectedGroupId,
        isForDownload: true,
        ...(selectedYearGroupId !== ALL_YEARS && {
            yearGroupEnum: selectedYearGroupId
        }),
        userProfileId: participationData && participationData.userProfileId,
        teacherUserProfileId:
            selectedTeacherId === ALL_TEACHERS
                ? ALL_TEACHERS_ID
                : selectedTeacherId
    };
    const getStudentName = () => {
        if (participationData) {
            return `${participationData.firstName}_${participationData.lastName}`;
        }
        return null;
    };

    return (
        <div className={css.certificates}>
            <Certificates
                config={newCertificatesConfig}
                heading={certificates}
                certificates={
                    participationData && participationData.newCertificates
                }
                handleCertificateDownloadClick={(payload) => {
                    const { certificatesCount, certificateTypeName } = payload;
                    newCertificatesDownloadStudentByType({
                        ...payload,
                        userId: selectedStudentId,
                        fileNameOverride: getCertificateFilename({
                            title: getStudentName(),
                            certificatesCount,
                            certificateTypeName,
                            prefixCertificate: false
                        })
                    });
                }}
                {...certificateProps}
            />
            <Certificates
                config={pastCertificatesConfig}
                heading={oldCertificates}
                isOldCertificates
                certificates={
                    participationData && participationData.certificates
                }
                handleCertificateDownloadClick={(payload) => {
                    const { certificatesCount, certificateTypeName } = payload;
                    pastCertificatesDownloadByType({
                        ...payload,
                        fileNameOverride: getCertificateFilename({
                            title: getStudentName(),
                            certificatesCount,
                            certificateTypeName,
                            prefixCertificate: false
                        })
                    });
                }}
                {...certificateProps}
            />
        </div>
    );
};

StudentCertificates.propTypes = {
    participationData: PropTypes.object || null,
    selectedClassroomId: PropTypes.number,
    selectedGroupId: PropTypes.number,
    selectedStudentId: PropTypes.number,
    newCertificatesDownloadStudentByType: PropTypes.func,
    pastCertificatesDownloadByType: PropTypes.func,
    selectedYearGroupId: PropTypes.number,
    selectedTeacherId: PropTypes.number
};

export default styleable(css)(StudentCertificates);



// WEBPACK FOOTER //
// ./containers/participation/student/components/student-certificates.js